import { FC } from 'react';
import { localeStore } from 'src/mobx/localesStore';
import { booleanToNumber } from 'src/utils/helpers';
import Switcher from 'src/view/components/Controls/Switcher/Switcer';
import Text, { TEXT } from 'src/view/components/Text/Text';
import { IPosIntRestriction } from '~/types/integrations';
import { TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import IntegrationManager from '~/view/components/IntegrationManager/IntegrationManager';

interface IProps {
  fullDay: boolean;
  posIntRestriction: IPosIntRestriction;
  error: boolean;
  onChange: () => void;
}

const FullDayStatusSwitcher: FC<IProps> = ({ fullDay, posIntRestriction, error, onChange }): JSX.Element => {
  return (
    <>
      <div className="d-flex align-items-center mt-6">
        <IntegrationManager
          setting={posIntRestriction.access}
          withTooltip
          tooltipOptions={{ show: posIntRestriction.shouldDisable, minWidth: 355, position: TOOLTIP_POSITION.PORTAL }}
        >
          <Switcher status={booleanToNumber(fullDay)} error={error} onChange={onChange} className="mr-4" />
        </IntegrationManager>
        <Text
          text="timeslot_open_24_hours_toggle"
          type={TEXT.CUSTOM}
          className="family-medium text-size-18"
          disabled={posIntRestriction.shouldDisable}
        />
      </div>
      {error && <p className="family-regular text-size-14 color-red mt-2">{localeStore.t('timeslot_is_superimposed_error')}</p>}
    </>
  );
};

export default FullDayStatusSwitcher;
